import styled from 'styled-components';

const MultiInput = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export default MultiInput;
